import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { Box } from '@mui/system';

import { VpIcon } from './';
import styles from './VpDialogTitle.module.less';

export const VpDialogTitle = ({
  onClose = null,
  leftContent = '',
  centerContent = '',
  contextMenu = null
}) => {
  return (
    <DialogTitle className={styles.titleStyles}>
      <Box className={`${styles.divStyles} ${styles.leftContent}`}>{leftContent}</Box>
      <Box className={`${styles.divStyles} ${styles.centerContent}`}>{centerContent}</Box>
      <Box className={styles.leftGrid}>
        {contextMenu && contextMenu}
        {onClose && (
          <IconButton className={styles.buttonStyles} edge="end" onClick={onClose} fontSize="large">
            <VpIcon icon="X" />
          </IconButton>
        )}
      </Box>
    </DialogTitle>
  );
};

VpDialogTitle.propTypes = {
  leftContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  centerContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClose: PropTypes.func,
  contextMenu: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpDialogTitle.jsx